import { render, staticRenderFns } from "./cookie-consent-bar.vue?vue&type=template&id=4172e740"
import script from "./cookie-consent-bar.vue?vue&type=script&lang=js"
export * from "./cookie-consent-bar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports